import type { BadgeTone } from '@/components/ui/badge';
import { PROGRESS_COMPARISON_CLASSIFICATION } from '@/constants/progressMetrics';

export function formatProgressNumber(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

export function formatSignedProgressDelta(delta: number): string {
  if (delta > 0) {
    return '+' + formatProgressNumber(delta);
  }
  return formatProgressNumber(delta);
}

export function resolveComparisonBadgeTone(classification: string): BadgeTone {
  if (classification === PROGRESS_COMPARISON_CLASSIFICATION.improved) {
    return 'success';
  }
  if (classification === PROGRESS_COMPARISON_CLASSIFICATION.worsened) {
    return 'danger';
  }
  if (classification === PROGRESS_COMPARISON_CLASSIFICATION.unchanged) {
    return 'neutral';
  }
  return 'muted';
}
